import { createTheme } from "@mui/material";
import OpenSansTtf from './OpenSansRegular.ttf'

export function getTheme(){

    const theme = createTheme({
        typography: { 
            fontFamily: 'Open Sans, sans-serif',
            subheaderText: {
                fontSize: { xs: '16px', sm: '17px', md: '18px' },
                fontWeight: 400,
                fontFamily: 'Open Sans, sans-serif'
            }
        },
        cssVariables: { colorSchemeSelector: "class" },
        colorSchemes: {
            light: {
                palette: {
                    primary: {
                        main: "#06569D",
                        hover: "#108DF9",
                    },
                    error: {
                        main: "#DC0000", 
                        hover: "#DC375C",
                    },
                    text: {
                        primary: "#000000",
                    },
                    TableCell: {
                        border:"2px solid #FFFFFF", // "#7DAED3"
                        borderLeft: "2px solid #FFFFFF",
                        background: "#E9E9E9",
                        hover: "#D9D9D9",
                    },
                    NavigationBar: {
                        background: "#D9D9D9",
                    },
                    sortButton: {
                        background: '#BFBFBF',
                        text: '#06569D',
                        selectedText: '#FFFFFF',
                        hover: '#D9D9D9',
                        selected: '#06569D',
                        border: '1px solid #BFBFBF',
                        bottomBorder: '3px solid #E9E9E9',
                    },
                    ChannelPage: {
                        background: '#E3E3E3',
                        foreground: '#ECECEC',
                        subheader:{
                            background: '#E9E9E9',
                            desktopdivider: '#BABABA',
                            mobiledivider: '#06569D',
                            fontdefault: '#06569D',
                            fontfilled: '#FFF',
                            gray: '#BFBFBF',
                            grayhighlight: '#C9F71B',
                            logoFallback: '#007CEB',
                            heights: {
                                xs: '60px',
                                sm: '65px', 
                                md: '65px',
                                lg: '70px'
                            },
                            spacing: {
                                xs: { mobile: 1.5, desktop: 2 },
                                sm: 2,
                                md: 2.5,
                                lg: 3
                            },
                            layout: {
                                stickyTop: '95px',
                                zIndex: 10
                            }
                        },
                        stationcontacts: '#BFBFBF',
                    },
                    ContactEditor: {
                        background: "#E3E3E3",
                        textFieldFilled: "#ECECEC",
                        gray: '#BFBFBF',
                        dividerColor: '#5189BA',
                        focusBorderColor: '#75BCFA',
                        border: '2px solid #000',
                        dangerColor: '#9D0606',
                    },
                    DashboardTile: {
                        banner: {
                            background: '#B9D3E9',
                            color: "#043B6C", 
                        },
                        maindisplay: {
                            background: '#F2F2F2',  
                            color: '#06569D',    
                        },

                    },

                    Map: {
                        window: {
                            background: "#F4F4F4",
                            stroke: "#ACACAC"
                        },
                        landscape: {
                            fill: "#CACACA",
                            stroke: "#000000",
                        },
                        item: {
                            fill: "#08559D",
                            stroke: "#000000",
                            liveFill: "#FD0013",
                        },
                    }
                },
            },
            dark: {
                palette: {
                    background: {
                        default: "#2e2e2e",
                        paper: "#2e2e2e",
                    },
                    primary: {
                        main: "#06569D",
                        hover: "#9DCFFB",
                    },
                    error: {
                        main: "#DC0000",
                        hover: "#DC375C",
                    },
                    TableCell: {
                        border: "2px solid #2c2c2c",
                        borderLeft: "2px solid #2c2c2c",
                        background: "#4a4a4a",
                        hover: "#353535",
                    },
                    NavigationBar: {
                        background: "#000000",
                    },
                    sortButton: {
                        background: '#414141',
                        text: '#FFFFFF',
                        selectedText: '#FFFFFF',
                        hover: '#353535',
                        selected: '#06569D',
                        border: '1px solid #414141',
                        bottomBorder: '3px solid #000000',
                    },
                    ChannelPage: {
                        background: '#2E2E2E',
                        foreground: '#434343',
                        subheader: {
                            background: '#393939',
                            desktopdivider: '#6D6D6D',
                            mobiledivider: '#FFFFFF',
                            fontdefault: '#FFF',
                            fontfilled: '#FFF',
                            gray: '#646464',
                            grayhighlight: '#6E9BC0',
                            logoFallback: '#007CEB',
                            heights: {
                                xs: '60px',
                                sm: '65px', 
                                md: '65px',
                                lg: '70px'
                            },
                            spacing: {
                                xs: { mobile: 1.5, desktop: 2 },
                                sm: 2,
                                md: 2.5,
                                lg: 3
                            },
                            layout: {
                                stickyTop: '95px',
                                zIndex: 10
                            }
                        },
                        stationcontacts: '#4B4B4B',
                    },
                    ContactEditor: {
                        background: "#2E2E2E",
                        textFieldFilled: "#434343",
                        gray: '#646464',
                        dividerColor: '#5189BA',
                        focusBorderColor: '#75BCFA',
                        border: '2px solid #000',
                        dangerColor: '#9D0606',
                    },
                    DashboardTile: {
                        banner: {
                            background: '#06569D',
                            color: "#9DCFFB",
                        },
                        maindisplay: {
                            background: '#1C1C1C',
                            color: '#B9D3E9',  
                        },
                    },
                    Map: {
                        window: {
                            background: "#000000",
                            stroke: "#737373"
                        },
                        landscape: {
                            fill: "#3C3C3C",
                            stroke: "#FFFFFF",
                        },
                        item: {
                            fill: "#0060C0",
                            stroke: "#FFFFFF",
                            liveFill: "#FD0013",
                        },
                    }
                },
            },
        },
        components: {
            MuiCssBaseline: {
                styleOverrides: {
                    '@font-face': [
                        {
                            fontFamily: 'Open Sans',
                            fontStyle: 'normal',
                            fontDisplay: 'swap',
                            fontWeight: 400,
                            src: `url(${OpenSansTtf}) format('truetype')`,
                        },
                    ],
                },
            },
            MuiButton: {
                variants: [
                    {
                        props: { variant: 'subheader' },
                        style: {
                            width: '105px',
                            height: '35px',
                            fontSize: { xs: '16px', sm: '17px', md: '18px' },
                            fontWeight: 400,
                            borderRadius: 0,
                            textTransform: 'none',
                            minWidth: 'unset',
                            padding: {
                                xs: '4px 8px',
                                sm: '4px 9px',
                                md: '5px 10px'
                            }
                        }
                    },
                    {
                        props: { variant: 'subheaderWide' },
                        style: {
                            height: '35px',
                            fontSize: { xs: '16px', sm: '17px', md: '18px' },
                            fontWeight: 400,
                            borderRadius: 0,
                            textTransform: 'none',
                            minWidth: 'unset',
                            padding: {
                                xs: '4px 8px',
                                sm: '4px 9px',
                                md: '5px 10px'
                            }
                        }
                    },
                    {
                        props: { variant: 'schedule' },
                        style: {
                            height: '35px',
                            fontSize: { xs: '16px', sm: '17px', md: '18px' },
                            fontWeight: 400,
                            borderRadius: '20px',
                            textTransform: 'none',
                            minWidth: 'unset',
                            padding: '5px 10px'
                        }
                    }
                ]
            },
            MuiDataGrid: {
                styleOverrides: {
                    root: {
                        "--DataGrid-containerBackground":
                            "var(--mui-palette-primary-main)",
                    },
                    columnHeaders: {
                        color: "var(--mui-palette-secondary-contrastText)",
                    },
                    columnSeparator: {
                        color: "var(--mui-palette-secondary-contrastText)",
                    },
                    columnHeaderTitle: {
                        fontWeight: "bold",
                    },
                    sortIcon: {
                        color: "var(--mui-palette-secondary-contrastText)",
                    },
                    menuIconButton: {
                        color: "var(--mui-palette-secondary-contrastText)",
                    },
                    "cell--editing": {
                        backgroundColor:
                            "var(--mui-palette-background-default)",
                    },
                },
            },
        },
    });

    return theme
}
